import { useSyncExternalStore, useDebugValue, useMemo } from 'react';
import { useHubspotContext, HUBSPOT_LOADED_EVENT } from './HubspotProvider.js';

const subscribe = (callback) => {
    window.addEventListener(HUBSPOT_LOADED_EVENT, callback);
    return () => window.removeEventListener(HUBSPOT_LOADED_EVENT, callback);
};
const getHubspot = () => window.hubspot || null;
const getHbspt = () => window.hbspt || null;
const getServerSnapshot = () => null;
/**
 * A custom hook that provides access to HubSpot-related data and functionality.
 *
 * This hook combines context data from `useHubspotContext` with synchronized external
 * store values for `hubspot` and `hbspt`.
 *
 * @returns An object containing:
 * - `hubspot`: Global window HubSpot object or `null` if not loaded.
 * - `hbspt`: Global window Hbspt object or `null` if not loaded.
 * - Additional context data from `useHubspotContext`.
 */
const useHubspot = () => {
    const context = useHubspotContext();
    const hubspot = useSyncExternalStore(subscribe, getHubspot, getServerSnapshot);
    const hbspt = useSyncExternalStore(subscribe, getHbspt, getServerSnapshot);
    useDebugValue(`hubspot: `, hubspot);
    useDebugValue(`hbspt: `, hbspt);
    const value = useMemo(() => ({
        ...context,
        hubspot,
        hbspt,
    }), [context, hubspot, hbspt]);
    return value;
};

export { useHubspot };
